import * as React from "react";
const SvgIcClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 4.00005L4 12M12 12L4 4", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
export default SvgIcClose;
